import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Persona } from './entity-personas.model';

// LOAD
export const entityPersonasLoadRequest = createAction(
  '[ENTITYPERSONAS] Load Request'
);

export const entityPersonasLoadFailure = createAction(
  '[ENTITYPERSONAS] Load Failure',
  props<{ error: Error }>()
);

export const entityPersonasLoadSuccess = createAction(
  '[ENTITYPERSONAS] Load Success',
  props<{ items: Persona[] }>()
);

// ADD
export const entityPersonasAddRequest = createAction(
  '[ENTITYPERSONAS] Add Request',
  props<{ item: Persona }>()
);

export const entityPersonasAddFailure = createAction(
  '[ENTITYPERSONAS] Add Failure',
  props<{ error: Error }>()
);

export const entityPersonasAddSuccess = createAction(
  '[ENTITYPERSONAS] Add Success',
  props<{ item: Persona }>()
);

// CHANGE
export const entityPersonasChangeRequest = createAction(
  '[ENTITYPERSONAS] Change Request',
  props<{ item: Persona }>()
);

export const entityPersonasChangeRequestWithoutRedirection = createAction(
  '[ENTITYPERSONAS] Change Request Without Redirection',
  props<{ item: Persona }>()
);

export const entityPersonasChangeFailure = createAction(
  '[ENTITYPERSONAS] Change Failure',
  props<{ error: Error }>()
);

export const entityPersonasChangeSuccess = createAction(
  '[ENTITYPERSONAS] Change Success',
  props<{ item: Update<Persona> }>()
);

export const entityPersonasChangeSuccessWithoutRedirection = createAction(
  '[ENTITYPERSONAS] Change Success Without Redirection',
  props<{ item: Update<Persona> }>()
);

// DELETE
export const entityPersonasDeleteRequest = createAction(
  '[ENTITYPERSONAS] Delete Request',
  props<{ item: Persona }>()
);

export const entityPersonasDeleteFailure = createAction(
  '[ENTITYPERSONAS] Delete Failure',
  props<{ error: Error }>()
);

export const entityPersonasDeleteSuccess = createAction(
  '[ENTITYPERSONAS] Delete Success',
  props<{ item: Persona }>()
);
